import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getApiV1WeddingsByWeddingIdAuthMeOptions } from '@wedding-tech/api-client/tanstack'

import { FullPageSpinnerPortal } from '@/components/common/Spinner/FullPagePortal'
import { TicketCard } from '@/components/tickets/TicketCard'

export const Route = createFileRoute('/e/$eventId/_dashboard/profile')({
  component: ProfilePage,
})

function ProfilePage() {
  const { eventId } = Route.useParams()
  const { data: authMe, isLoading } = useQuery(
    getApiV1WeddingsByWeddingIdAuthMeOptions({ path: { weddingId: eventId } }),
  )

  if (isLoading) {
    return <FullPageSpinnerPortal />
  }

  const profile = authMe?.profile
  const checkIn = authMe?.checkInDetail

  const ticket = {
    id: authMe?.profile?.fullName || authMe?.profile?.displayName,
    isPrimaryGuest: true,
    firstName: profile?.fullName?.split(' ')[0] || null,
    lastName: profile?.fullName?.split(' ').slice(1).join(' ') || null,
    displayName: profile?.displayName || null,
    contactPhone: null,
    email: (profile as any)?.email || null,
    status: (authMe?.status?.hasCheckedIn ? 'claimed' : 'pending') as
      'pending' | 'claimed',
    claimedAt: checkIn?.checkedInAt || null,
  }

  return (
    <div className="flex min-h-dvh flex-col bg-stone-50 pb-24">
      <main className="flex-1 space-y-8 px-6 py-12">
        <section className="text-center">
          <h1 className="text-3xl font-bold text-stone-900">โปรไฟล์ของคุณ</h1>
          <p className="text-stone-500">ข้อมูลส่วนตัวและบัตรเข้างาน</p>
        </section>

        <section className="mx-auto max-w-sm">
          <TicketCard ticket={ticket} />
        </section>
      </main>
    </div>
  )
}
